var map = {
	"./aparthotelclub/ic_chat_colored.png": 52804,
	"./beachful/ic_chat_colored.png": 52098,
	"./castlepedia/ic_chat_colored.png": 39893,
	"./cocktayl/ic_chat_colored.png": 7373,
	"./ic_chat_colored.png": 10327,
	"./luxresortclub/ic_chat_colored.png": 96810,
	"./parkful/ic_chat_colored.png": 54378,
	"./prefabworld/ic_chat_colored.png": 95097,
	"./rooftopclub/ic_chat_colored.png": 50419,
	"./spaclub/ic_chat_colored.png": 24318,
	"./worldcasino/ic_chat_colored.png": 39026,
	"./zoopedia/ic_chat_colored.png": 22617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17631;